import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useRouter } from "next/router";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import CloseButton from "@/components/common/close-button";

const InquirySuccessDialog = ({ open }) => {
  const router = useRouter();
  const handleClose = () => {
    router.push("/");
  };

  return (
    <Transition appear show={open} as={React.Fragment}>
      <Dialog
        onClose={handleClose}
        as="div"
        className="relative z-modal-backdrop"
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50 dark-theme:bg-black/70" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="card container relative max-h-[80vh] w-auto transform overflow-x-hidden text-left align-middle transition-all dark-theme:border dark-theme:border-auto-black/30">
                <div className="flex h-full w-full flex-col place-items-center gap-4 p-4 sm:p-8">
                  <CloseButton onClick={handleClose} />
                  <div className="flex w-full flex-col place-items-center">
                    <CheckCircleIcon className="w-24 text-primary-800/80" />
                    <h2 className="p-0">Hang on tight!</h2>
                  </div>
                  <h3 className="p-0 text-center">
                    We will get back to you as soon as possible.
                  </h3>
                </div>
                <div className="flex w-full justify-end px-4 pb-4">
                  <button className="button w-32" onClick={handleClose}>
                    OK
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default InquirySuccessDialog;
